<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import { computed, ref } from 'vue';
import store from "../../state/store";
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import '@jobinsjp/vue3-datatable/dist/style.css';

const title = ref('Print OVR (Dot Matrix)');

const items = ref([
  {
    text: "Home",
  },
    {
    text: "OVR",
  },
  {
    text: "Print OVR (Dot Matrix)",
    active: true,
  }
]);

const loading = computed(() => store.state.globals.loading);

const ovrDotMatrix = computed(() => store.state.ovr.ovrDotMatrix);

const ovrDotMatrixPagination = computed(() => store.state.ovr.ovrDotMatrixPagination);

const query = ref({
  search: ''        
});

const getOVRDotMatrix = async (dt) => {
  try {
    await store.dispatch('ovr/getOVRDotMatrix', {
      page: dt.page,
      page_size: dt.per_page,
      sortColumn: 'updated_at',
      search: dt.search,
      orderBy: 'desc'
    });
  } catch (err) {
    console.log(err)
  }
}

const viewBatchNumber = () => {
  alert('View button is still under construction. Please try again later!');
}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12 col-md-6 col-xl-4">
          <b-overlay :show="loading">
            <div class="card">
              <div class="card-header">
                <h4>Search batch number</h4>
              </div>
            <div class="card-body">
                 <div class="row">
                  <div class="col lg-12">
                      <data-table
                          :rows="ovrDotMatrix"
                          :pagination="ovrDotMatrixPagination"
                          striped
                          :loading="loading"
                          :query="query"
                          filter
                          hoverable
                          sortable
                          @loadData="getOVRDotMatrix"
                          >
                          <template #thead>
                              <table-head>Batch #</table-head>
                              <table-head>Action</table-head>
                          </template>

                          <template #tbody="{row}">
                              <table-body>{{ row.batch_number ? row.batch_number : 'n/a' }}</table-body>
                              <table-body>
                                <button @click="viewBatchNumber" class="btn btn-sm btn-info">
                                  <i class="mdi mdi-eye"></i> View
                                </button>
                              </table-body>
                          </template>

                          <template #empty>
                          <TableBodyCell colspan="10">
                              No results found
                          </TableBodyCell>
                      </template>
                      </data-table>
                  </div>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
        <div class="col-xs-12 col-md-6 col-xl-8 text-center">
          <b-overlay :show="loading">
            <div class="card">
              <div class="card-body">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <h4 class="mt-4 fw-semibold">Print OVR (Dot Matrix)</h4>
                    <p class="text-muted mt-3 fs-5"> 
                      Batch number information will show up here
                    </p>
                  </div>
                </div>
                <div class="row justify-content-center mt-5 mb-2">
                  <div class="col-sm-7 col-8">
                    <img src="@/assets/images/file.png" alt="" class="img-fluid" width="400">
                  </div>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>
  </Layout>
</template>